<section class="page-container">

    <div class="container-fluid ptCustom">

        <div class="my-2">
            <a [routerLink]="['/admin-portal/chamber/pending-letters']" class="text-white"><i class="fa-regular fa-angle-left"></i> back to all pending letters</a>
        </div>

        <div class="row">

            <div class="col-lg-8 col-md-8 my-2">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer">
                            <div class="detailsHeader">
                                <h4>Letter Content</h4>
                                <a href="javascript:void(0);" (click)="openEditModal()" *ngIf="!letter.isClosed"><i class="fa-regular fa-pencil"></i></a>
                            </div>
                            <div class="detailsSection">
                                <div class="row">
                                    <div class="col">
                                        <div class="detailsBlock introLetterContent">
                                            <div [innerHTML]="letter.letterContent">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 my-2">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer">
                            <div class="detailsHeader justify-content-center">
                                <h4>Review Letter</h4>
                            </div>
                            <div class="detailsSection">
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Requesting Member</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span class="d-block">{{letter.requestingMember}}</span>
                                        <small class="text-muted">{{letter.requestingCompany}}</small>
                                    </div>
                                </div>
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Letter Recipient</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span class="d-block">{{letter.recipientMember}}</span>
                                        <small class="text-muted">{{letter.recipientCompany}}</small>
                                    </div>
                                </div>
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Current Cycle Usage</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span class="d-block">{{letter.lettersUsed}}/10 Letters Used</span>
                                        <small class="text-muted fst-italic">{{lettersLeft}} available until {{letter.cycleEndTime}}</small>
                                    </div>
                                </div>
                                <div *ngIf="!letter.isClosed">
                                    <div class="mb-3">
                                        <input [(ngModel)]="letter.approverNotes" type="text" class="form-control" id="exampleNotes" placeholder="Notes">
                                    </div>
                                    <div class="mb-4">
                                        <a href="javascript:void(0);" (click)="PublishArticle(1)" type="button" class="btn btn-add text-strong hvr-grow w-100"><i class="fa-solid fa-check"></i> approve letter</a>
                                    </div>
                                    <div class="text-center">
                                        <a href="javascript:void(0);" (click)="PublishArticle(2)" class="text-white"><small>reject letter</small></a>
                                    </div>
                                </div>

                                <div *ngIf="letter.isClosed">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Status</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span class="d-block">{{letter.status}}</span>
                                        </div>
                                    </div>
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Notes</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span class="d-block">{{letter.approverNotes}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>



</section>